import React, { useState } from 'react';
import { PHONE, PHONE_DISPLAY } from '../../data/appData';
const ADDRESS = 'Güzelkent Mahallesi 369. Sokak, Ankara';
const MAPS_URL = 'https://www.google.com/search?q=Ta%C5%9Fg%C4%B1n+Tesisat&stick=H4sIAAAAAAAA_-NgU1I1qDAyTE00TTRPSkszSDI2TkqzAgolmRhbWloYJaUaWKZYGhouYhUISTw6P_3IxjyFkNTizOLEEgCEZBjnPAAAAA&hl=tr&mat=CWiVbslUKrkKElcBTVDHnqfNfDgkomJDBfF-1cUpv4zQ1ensjHBM41FhbUEVhdrsnu1kkSqTqHE_i4zt7_rPmdFIuTaKm_58LV1VTSTCq0V1em0gLabMJwFWHWn1rUmz2dI&authuser=0';

export default function ContactSection() {
  const [showPhone, setShowPhone] = useState(false);

  return (
    <section className="section" style={{ background: 'var(--bg-primary)' }}>
      <div className="container">
        <div className="section-header">
          <div className="section-eyebrow">İletişim</div>
          <h2 className="section-title">
            Bize<br/>
            <span className="gradient-text">Ulaşın</span>
          </h2>
          <p className="section-subtitle">
            Pzt–Cmt 08:00–20:00 arası hizmet veren ekibimiz tüm tesisat sorunlarınız için hazır.
          </p>
        </div>

        <div className="contact-grid" style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '32px', alignItems: 'start' }}>

          {/* Sol – harita + kartlar */}
          <div style={{ display: 'flex', flexDirection: 'column', gap: '20px' }}>
            {/* Harita */}
            <div
              style={{ background: 'var(--gradient-metal)', borderRadius: 'var(--radius-xl)', height: '280px', display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', border: '1px solid rgba(0,180,204,0.3)', position: 'relative', overflow: 'hidden', cursor: 'pointer', transition: 'all 0.3s ease', animation: 'glow-border 3s ease-in-out infinite' }}
              onClick={() => window.open(MAPS_URL, '_blank')}
              onMouseEnter={e => { e.currentTarget.style.transform = 'translateY(-4px)'; e.currentTarget.style.boxShadow = '0 20px 60px rgba(0,180,204,0.25)'; }}
              onMouseLeave={e => { e.currentTarget.style.transform = 'translateY(0)'; e.currentTarget.style.boxShadow = 'none'; }}
            >
              <div style={{ position: 'absolute', inset: 0, backgroundImage: `linear-gradient(rgba(0,212,240,0.06) 1px, transparent 1px), linear-gradient(90deg, rgba(0,212,240,0.06) 1px, transparent 1px)`, backgroundSize: '40px 40px' }}/>
              <svg style={{ position: 'absolute', inset: 0, width: '100%', height: '100%' }} xmlns="http://www.w3.org/2000/svg">
                <path d="M0,140 L500,120" stroke="rgba(0,180,204,0.2)" strokeWidth="8" fill="none"/>
                <path d="M0,200 L500,180" stroke="rgba(0,180,204,0.15)" strokeWidth="5" fill="none"/>
                <path d="M200,0 L220,300" stroke="rgba(0,180,204,0.2)" strokeWidth="8" fill="none"/>
                <path d="M350,0 L360,300" stroke="rgba(0,180,204,0.12)" strokeWidth="4" fill="none"/>
              </svg>
              <div style={{ position: 'relative', zIndex: 1, textAlign: 'center' }}>
                <div style={{ fontSize: '40px', marginBottom: '8px', filter: 'drop-shadow(0 4px 8px rgba(0,0,0,0.4))', animation: 'float 3s ease-in-out infinite' }}>📍</div>
                <div style={{ color: 'white', fontFamily: 'var(--font-display)', fontWeight: 700, fontSize: '1rem' }}>Güzelkent, Ankara</div>
                <div style={{ color: 'rgba(255,255,255,0.6)', fontSize: '0.82rem', marginTop: '4px' }}>Google Haritalar'da Aç ↗</div>
              </div>
            </div>

            {/* İletişim kartları */}
            <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '12px' }}>
              {[
                { icon: '📞', label: 'Telefon', value: PHONE_DISPLAY, sub: 'Pzt–Cmt 08:00–20:00', href: `tel:${PHONE}` },
                { icon: '📱', label: 'WhatsApp', value: PHONE_DISPLAY, sub: 'Pzt–Cmt 08:00–20:00', href: `https://wa.me/90${PHONE.substring(1)}` },
                { icon: '📍', label: 'Adres', value: 'Güzelkent Mah. 369. Sok.', sub: 'Ankara', href: MAPS_URL, accent: false, target: '_blank' },
                { icon: '⏰', label: 'Çalışma Saati', value: '08:00 – 20:00', sub: 'Pazar hariç her gün', href: null, accent: true },
              ].map(c => (
                c.href
                  ? <a key={c.label} href={c.href} target={c.href.startsWith('http') ? '_blank' : undefined} rel="noreferrer" style={{ padding: '16px', borderRadius: 'var(--radius-lg)', background: c.accent ? 'rgba(255,107,53,0.06)' : 'var(--bg-card)', border: `1px solid ${c.accent ? 'rgba(255,107,53,0.25)' : 'var(--border-color)'}`, textDecoration: 'none', transition: 'all 0.2s', display: 'block' }}>
                      <div style={{ fontSize: '20px', marginBottom: '6px' }}>{c.icon}</div>
                      <div style={{ fontWeight: 700, color: c.accent ? 'var(--accent-orange)' : 'var(--text-primary)', fontSize: '0.88rem' }}>{c.value}</div>
                      <div style={{ fontSize: '0.72rem', color: 'var(--text-muted)', marginTop: '2px' }}>{c.sub}</div>
                    </a>
                  : <div key={c.label} style={{ padding: '16px', borderRadius: 'var(--radius-lg)', background: 'var(--bg-card)', border: '1px solid var(--border-color)', display: 'block' }}>
                      <div style={{ fontSize: '20px', marginBottom: '6px' }}>{c.icon}</div>
                      <div style={{ fontWeight: 700, color: 'var(--accent-orange)', fontSize: '0.88rem' }}>{c.value}</div>
                      <div style={{ fontSize: '0.72rem', color: 'var(--text-muted)', marginTop: '2px' }}>{c.sub}</div>
                    </div>
              ))}
            </div>
          </div>

          {/* Sağ – randevu al kutusu */}
          <div style={{ background: 'var(--gradient-hero)', borderRadius: 'var(--radius-xl)', padding: '40px', border: '1px solid rgba(0,180,204,0.2)', boxShadow: 'var(--shadow-lg)', display: 'flex', flexDirection: 'column', alignItems: 'center', textAlign: 'center', gap: '24px' }}>
            <div style={{ fontSize: '64px', animation: 'float 3s ease-in-out infinite' }}>📞</div>
            <div>
              <h3 style={{ fontFamily: 'var(--font-display)', fontSize: '1.6rem', color: 'white', marginBottom: '12px', fontWeight: 800 }}>
                Hemen Randevu Alın
              </h3>
              <p style={{ color: 'rgba(255,255,255,0.7)', fontSize: '1rem', lineHeight: 1.6 }}>
                Arayın, uzmanlarımız sizi en uygun vakitte ziyaret etsin. Pzt–Cmt 08:00–20:00 arası hizmet veriyoruz.
              </p>
            </div>

            {/* Big phone reveal button */}
            {!showPhone ? (
              <button
                onClick={() => setShowPhone(true)}
                style={{ width: '100%', padding: '20px 32px', borderRadius: 'var(--radius-xl)', background: 'var(--accent-orange)', border: 'none', color: 'white', fontFamily: 'var(--font-display)', fontWeight: 800, fontSize: '1.25rem', cursor: 'pointer', boxShadow: '0 8px 32px rgba(255,107,53,0.5)', transition: 'all 0.2s', letterSpacing: '-0.01em' }}
              >
                🚨 Randevu Almak İçin Ara
              </button>
            ) : (
              <a
                href={`tel:${PHONE}`}
                style={{ width: '100%', padding: '20px 32px', borderRadius: 'var(--radius-xl)', background: 'rgba(37,211,102,0.15)', border: '2px solid rgba(37,211,102,0.5)', color: '#25D366', fontFamily: 'var(--font-display)', fontWeight: 800, fontSize: '1.5rem', cursor: 'pointer', boxShadow: '0 8px 32px rgba(37,211,102,0.2)', transition: 'all 0.2s', letterSpacing: '0.02em', textDecoration: 'none', display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '12px', animation: 'pulse-glow 2s infinite' }}
              >
                📞 {PHONE_DISPLAY}
              </a>
            )}

            <a
              href={`https://wa.me/90${PHONE.substring(1)}?text=Merhaba, randevu almak istiyorum.`}
              target="_blank"
              rel="noreferrer"
              style={{ display: 'flex', alignItems: 'center', gap: '10px', padding: '14px 28px', borderRadius: 'var(--radius-full)', background: 'rgba(37,211,102,0.1)', border: '1px solid rgba(37,211,102,0.3)', color: '#25D366', fontFamily: 'var(--font-display)', fontWeight: 700, fontSize: '0.95rem', textDecoration: 'none', transition: 'all 0.2s' }}
            >
              💬 WhatsApp ile Mesaj Gönder
            </a>

            <div style={{ display: 'flex', gap: '16px', flexWrap: 'wrap', justifyContent: 'center' }}>
              {['✅ Ücretsiz Keşif Yok', '⚡ 45 Dk Ulaşım', '🔒 Garanti Belgeli'].map(b => (
                <span key={b} style={{ fontSize: '0.78rem', color: 'rgba(255,255,255,0.55)', fontWeight: 500 }}>{b}</span>
              ))}
            </div>
          </div>
        </div>

        {/* Hizmet bölgeleri */}
        <div style={{ marginTop: '48px' }}>
          <h3 style={{ fontFamily: 'var(--font-display)', fontSize: '1.2rem', color: 'var(--text-primary)', marginBottom: '20px', textAlign: 'center' }}>
            📍 Hizmet Bölgelerimiz
          </h3>
          <div style={{ display: 'flex', flexWrap: 'wrap', gap: '8px', justifyContent: 'center' }}>
            {['Çankaya', 'Keçiören', 'Mamak', 'Altındağ', 'Yenimahalle', 'Etimesgut', 'Sincan', 'Pursaklar', 'Gölbaşı', 'Kahramankazan', 'Akyurt', 'Çubuk', 'Güzelkent', 'Bağlıca', 'Oran', 'Çayyolu'].map(d => (
              <span key={d} style={{ padding: '8px 16px', borderRadius: 'var(--radius-full)', background: 'var(--bg-card)', border: '1px solid var(--border-color)', fontSize: '0.85rem', color: 'var(--text-secondary)', fontWeight: 500 }}>📍 {d}</span>
            ))}
          </div>
        </div>
      </div>

      <style>{`
        @media (max-width: 768px) { .contact-grid { grid-template-columns: 1fr !important; } }
      `}</style>
    </section>
  );
}
